var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-m-0 gl-list-none gl-p-0 gl-pt-2"},_vm._l((_vm.componentNames),function(name,index){return _c(_vm.componentFromName(name),_vm._b({key:name,tag:"component",on:{"nothing-to-render":function($event){return _vm.remove(name)},"action":_vm.trackItems}},'component',_vm.attrs(index),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }